
import {
  DragDropContext,
  Droppable,
  DropResult,
  ResponderProvided,
} from "react-beautiful-dnd"
import List from "@mui/material/List/List"
import type { Item } from "./EditableList"
import { DraggableListItem } from "./DraggableListItem"
import { prop } from "ramda"

const reorder = (list: Item[], startIndex: number, endIndex: number) => {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  removed && result.splice(endIndex, 0, removed)

  return result
}

export function DraggableList({
  items,
  onReordered,
  onRemoveItem,
}: {
  items: Item[]
  onReordered: (r: string[]) => void
  onRemoveItem: any
}): JSX.Element {
  function onDragEnd(result: DropResult, provided: ResponderProvided) {
    if (!result.destination) return
    if (result.destination.index === result.source.index) return

    const newOrder = reorder(
      items,
      result.source.index,
      result.destination.index,
    )

    onReordered(newOrder.map(prop("id")))
  }

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="list">
        {/* @ts-ignore */}
        {(provided) => (
          <List ref={provided.innerRef} {...provided.droppableProps}>
            {items.map((item: Item, index: number) => (
              <DraggableListItem
                onRemoveItem={onRemoveItem}
                item={item}
                index={index}
                key={item.id}
              />
            ))}
            {provided.placeholder}
          </List>
        )}
      </Droppable>
    </DragDropContext>
  )
}
